module.exports = __webpack_public_path__ + "static/media/profile1.b00550c9.jpg";